export const PART_QUANTITY = 'quantity'
export const PART_STOCKPRICE = 'stockPrice'
export const PART_RUSHPRICE = 'rushPrice'
export const PART_ENDDATE = 'endDate'
export const PART_PRICETYPE = 'priceType'
export const PART_REFERENCE = 'reference'
export const PART_SUPERSEDED = 'partIsSuperSeded'
